import { LabelledLinkWebElementBase } from './LabelledLinkWebElementBase';

/**
 * The component WebElement for [oj-c-labelled-link](../../jsdocs/oj-c.LabelledLink.html).
 * Do not instantiate this class directly, instead, use
 * [findLabelledLink](../functions/findLabelledLink.html).
 */
export class LabelledLinkWebElement extends LabelledLinkWebElementBase {
  /**
   * Performs a click on the link
   */
  async click() {
    // find the link element
    const link = await this.findElement({ css: 'a' });
    await link.click();
  }
}
